import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=cd651bfa"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=cd651bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports